(function () {
  'use strict';

  var STORAGE_KEY = 'tcb-similar-compare';
  var MAX_COMPARE = 3;
  var VISIBLE = 4;

  function readSelection() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeSelection(items) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* ignore */
    }
  }

  function parseCard(card) {
    return {
      id: String(card.getAttribute('data-product-id') || ''),
      handle: card.getAttribute('data-product-handle') || '',
      title: card.getAttribute('data-product-title') || '',
      url: card.getAttribute('data-product-url') || '',
      price: parseInt(card.getAttribute('data-price') || '0', 10) || 0,
      psi: parseInt(card.getAttribute('data-psi') || '0', 10) || 0,
      heat: card.getAttribute('data-heat') === '1',
      portable: card.getAttribute('data-portable') === '1'
    };
  }

  function sortCards(cards, mode) {
    var list = cards.slice();
    if (mode === 'power') {
      list.sort(function (a, b) {
        return parseCard(b).psi - parseCard(a).psi || parseCard(a).price - parseCard(b).price;
      });
      return list;
    }
    if (mode === 'budget') {
      list.sort(function (a, b) {
        return parseCard(a).price - parseCard(b).price;
      });
      return list;
    }
    if (mode === 'portable') {
      list.sort(function (a, b) {
        var ap = parseCard(a).portable ? 1 : 0;
        var bp = parseCard(b).portable ? 1 : 0;
        return bp - ap || parseCard(a).price - parseCard(b).price;
      });
      return list;
    }
    if (mode === 'heat') {
      list.sort(function (a, b) {
        var ah = parseCard(a).heat ? 1 : 0;
        var bh = parseCard(b).heat ? 1 : 0;
        return bh - ah || parseCard(b).psi - parseCard(a).psi;
      });
      return list;
    }
    return list;
  }

  function applyFilter(panel, mode) {
    var cards = Array.prototype.slice.call(panel.querySelectorAll('[data-tcb-similar-card]'));
    if (!cards.length) return;

    var ordered = sortCards(cards, mode);
    ordered.forEach(function (card) {
      card.hidden = true;
    });

    var shown = 0;
    ordered.forEach(function (card) {
      if (shown >= VISIBLE) return;
      if (mode === 'portable' && !parseCard(card).portable) return;
      if (mode === 'heat' && !parseCard(card).heat) return;
      card.hidden = false;
      shown += 1;
    });

    if (shown === 0) {
      ordered.slice(0, VISIBLE).forEach(function (card) {
        card.hidden = false;
      });
    }
  }

  function syncCheckboxes(panel, selection) {
    panel.querySelectorAll('[data-tcb-similar-compare]').forEach(function (input) {
      var id = String(input.value || '');
      input.checked = selection.some(function (item) {
        return item.id === id;
      });
    });
  }

  function updateCompareLink(panel, selection) {
    var link = panel.querySelector('[data-tcb-similar-compare-link]');
    if (!link) return;
    var base = 'Compare up to 3';
    if (selection.length) {
      link.textContent = base + ' (' + selection.length + ' selected)';
    } else {
      link.textContent = base;
    }
  }

  function openCompareSection() {
    var compare = document.getElementById('tcb-pdp-compare');
    if (compare && compare.tagName === 'DETAILS') {
      compare.open = true;
    }
    if (compare && typeof compare.scrollIntoView === 'function') {
      compare.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initPanel(panel) {
    var filters = panel.querySelectorAll('[data-tcb-similar-filter]');
    var selection = readSelection();
    syncCheckboxes(panel, selection);
    updateCompareLink(panel, selection);
    applyFilter(panel, 'contractors');

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filters.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        applyFilter(panel, button.getAttribute('data-tcb-similar-filter') || 'contractors');
      });
    });

    panel.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.matches('[data-tcb-similar-compare]')) return;

      var card = input.closest('[data-tcb-similar-card]');
      if (!card) return;

      var item = parseCard(card);
      var current = readSelection();
      var exists = current.some(function (entry) {
        return entry.id === item.id;
      });

      if (input.checked) {
        if (exists) return;
        if (current.length >= MAX_COMPARE) {
          input.checked = false;
          window.alert('Select up to 3 products to compare.');
          return;
        }
        current.push(item);
      } else {
        current = current.filter(function (entry) {
          return entry.id !== item.id;
        });
      }

      writeSelection(current);
      updateCompareLink(panel, current);
    });

    panel.querySelectorAll('[data-tcb-similar-compare-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var selected = readSelection();
        if (selected.length) {
          openCompareSection();
        }
      });
    });

    if (typeof window.jdgm !== 'undefined' && typeof window.jdgm.loadWidgets === 'function') {
      window.jdgm.loadWidgets();
    }
  }

  function init() {
    document.querySelectorAll('[data-tcb-similar-panel]').forEach(initPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
